import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import { ILoginRequestDto } from "../../../common/dtos";
import { useLoginMutation } from "../../../queries/authentication.query";
import { getQueryParam } from "../../../helpers/nextHelper";

export default function useLogin() {
  const { t } = useTranslation();
  const { query } = useRouter();
  const isSessionExpired = getQueryParam(query, "isSessionExpired");
  const { mutateAsync: login } = useLoginMutation();
  const [error, setError] = useState(
    isSessionExpired === "1" ? t("login-session-expired") : ""
  );

  const onCloseError = () => setError("");

  const onLogin = async (dto: ILoginRequestDto) => {
    try {
      await login(dto);
    } catch (error) {
      if (error.status === 404) {
        setError(t("login-wrong-email-error"));
      } else {
        setError(error.errorMsg);
      }
    }
  };

  return {
    onLogin,
    onCloseError,
    error,
  };
}
